import PubSub from 'pubsub-js'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import AppState from 'shared/app_state'

export const usePageTracking = () => {
  const location = useLocation()

  useEffect(() => {
    const pii = AppState?.getCurrentAccount()?.id || 'no-pii-provided'
    const cleanPath = window.location.href.replace(pii, '...').replace('#', '')
    const url = cleanPath + location.search

    PubSub.publish('pageview', { url: url, title: document.title })
  }, [location])
}
